import { useState } from "react";
import SVG from "shared/SVG";
import "./TopNavigation.scss";
import { ROUTE_ENUM, SVG_ENUM, HOME_SCROLL_ENUM } from "enums";
import Button from "shared/Button/Button";
import { useNavigate } from "react-router";
import { isDesktop } from "utils";

type TopNavigationProps = {};

const TopNavigation: React.FC<TopNavigationProps> = () => {
  const navigate = useNavigate();
  const { INVESTOR, WHY_WORTH, PRICE, CONTACT } = HOME_SCROLL_ENUM;
  const [isActiveMobileMenu, setIsActiveMobileMenu] = useState(false);
  const handleScrollTo = (item: string) => {
    const element = document.getElementById(item);
    if (element) {
      const yOffset = item === CONTACT ? 30 : -70;
      const y =
        element.getBoundingClientRect().top + window.pageYOffset + yOffset;
      window.scrollTo({ top: y, behavior: "smooth" });
    }
    setIsActiveMobileMenu(false);
  };

  const TopNavigationItems = () => (
    <>
      <div className="top-navigation__items">
        <div
          className="top-navigation__item"
          onClick={() => handleScrollTo(INVESTOR)}
        >
          Jak to działa?
        </div>
        <div
          className="top-navigation__item"
          onClick={() => handleScrollTo(WHY_WORTH)}
        >
          Dlaczego warto?
        </div>
        <div
          className="top-navigation__item"
          onClick={() => handleScrollTo(PRICE)}
        >
          Cennik
        </div>
        <div
          className="top-navigation__item"
          onClick={() => handleScrollTo(CONTACT)}
        >
          Kontakt
        </div>
      </div>
      <nav className="top-navigation__right">
        <Button
          size="small"
          styleType="strokeBlack"
          label="Zaloguj się"
          onClick={() => navigate(ROUTE_ENUM.LOGIN)}
        />
      </nav>
    </>
  );

  return (
    <header className="top-navigation">
      <div className="top-navigation__container">
        <div className="layout">
          <div className="top-navigation__wrapper">
            <div
              className="top-navigation__left"
              onClick={() => navigate(ROUTE_ENUM.HOME)}
            >
              <SVG
                type={
                  isDesktop()
                    ? SVG_ENUM.LOGO
                    : isActiveMobileMenu
                    ? SVG_ENUM.LOGO_WHITE
                    : SVG_ENUM.LOGO
                }
              />
            </div>
            {isDesktop() ? (
              TopNavigationItems()
            ) : (
              <div className="top-navigation__mobile">
                <div
                  className="user"
                  onClick={() => navigate(ROUTE_ENUM.PROFILE)}
                >
                  <SVG type={SVG_ENUM.USER_CIRCLE} />
                </div>

                <div
                  className={`hamburger ${
                    isActiveMobileMenu ? "is-active" : ""
                  }`}
                  onClick={() => setIsActiveMobileMenu(!isActiveMobileMenu)}
                >
                  <span className="hamburger-line"></span>
                  <span className="hamburger-line"></span>
                  <span className="hamburger-line"></span>
                </div>
                <div
                  className={`top-navigation__mobile-menu ${
                    isActiveMobileMenu
                      ? "top-navigation__mobile-menu--active"
                      : ""
                  }`}
                >
                  {TopNavigationItems()}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default TopNavigation;
